class Request {
  constructor({ $strapi }) {
    this.$strapi = $strapi
  }
}

module.exports = Request
